import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import styles from './Badge.module.css';
export const Badge = forwardRef(({ variant = 'default', size = 'md', glass = false, dot = false, className = '', children, ...props }, ref) => {
    const classes = [
        styles.badge,
        styles[variant],
        styles[size],
        glass && styles.glass,
        dot && styles.dot,
        className,
    ]
        .filter(Boolean)
        .join(' ');
    return (_jsxs("span", { ref: ref, className: classes, ...props, children: [dot && _jsx("span", { className: styles.dotIndicator }), children] }));
});
Badge.displayName = 'Badge';
